import { registerFormInputComponent } from '@vendure/admin-ui/core';
import { MandatoryVariantsFormInput } from './input-form.component';

export default [
    registerFormInputComponent(
        'mandatory-variants-form-input',
        MandatoryVariantsFormInput
    ),
];
